"use strict";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { setHasShownMismatchToast } from "features/behaviorHistory/slice";
import { isExtension } from "utilities/src/platform";
import { useEvent } from "utilities/src/react/hooks";
import { useAccountEffect } from "wagmi";
export function useOnDisconnectEffectWeb() {
  const dispatch = useDispatch();
  const handleResetToastState = useEvent(() => {
    dispatch(setHasShownMismatchToast(false));
  });
  const value = useMemo(() => {
    return {
      onConnect: handleResetToastState,
      onDisconnect: handleResetToastState
    };
  }, [handleResetToastState]);
  useAccountEffect(value);
}
export const useOnDisconnectEffect = !isExtension ? useOnDisconnectEffectWeb : () => {
};
